// seatMain — ตรวจ Main Cashier ก่อนแอป mount
//
// Main มีงานเบื้องหลัง (watchHandshake / jobRequest / QR / live) ถ้ามีสองเครื่อง job ซ้ำ
// จึงต้องรู้ผลก่อน bootstrap เริ่ม (plugin async ถูก await ก่อน mount เสมอ)
//
//   เป็นของเรา → ใช้ต่อ + heartbeat
//   ว่าง → จองเงียบ ๆ
//   เป็นของเครื่องอื่น → public/seat/ask-main-cashier-override.html (แย่ง / เปลี่ยนโหมด)
//   ใช้อยู่แล้วโดนแย่ง → ล้างโหมด → public/seat/main-cashier-is-taken.html
//   ออฟไลน์ → รอ socket ไม่เกิน 3 วินาทีแล้วปล่อยใช้ ตรวจซ้ำตอนต่อติด
//   หน้า login / app1 ของร้าน beta → ไม่ตรวจ (ดู decideSkipSeatCheck)
import type { Router } from "vue-router";
import "../../../firebaseInstance";
import { RunMode } from "../../../interface/Pos";
import { resolveStoreId } from "../../core/composables/useStoreIdentity";
import { useRunningMode } from "../../core/composables/useRunningMode";
import { isDevReadOnly } from "../../core/utils/devStoreOverride";
import { SEAT_MODE_MAIN } from "../utils/seatRules";
import { DEVICE_BLOCKED_KEY, hasKey } from "../utils/seatStorage";
import { getSeatIdentity, guardSeat, holdUntilNavigation } from "../services/seatGuard";
import { shouldSkipSeatCheck } from "../services/seatScope";

export default defineNuxtPlugin({
  name: "seat-main",
  parallel: false,
  async setup(nuxtApp) {
    // จับไว้ก่อน await แรก — หลัง await ไม่อยู่ใน nuxt context แล้ว
    const router = nuxtApp.$router as Router;
    try {
      if (hasKey(DEVICE_BLOCKED_KEY)) return;

      const storeId = await resolveStoreId();
      if (!storeId || isDevReadOnly()) return;
      if (useRunningMode().getMode() !== RunMode.MAIN_CASHIER) return;

      const identity = getSeatIdentity(storeId);
      if (!identity) return;
      if (await shouldSkipSeatCheck(storeId, router)) return;

      const result = await guardSeat({
        storeId,
        mode: SEAT_MODE_MAIN,
        ...identity,
        getQuota: () => null, // Main ไม่ใช้โควตา
      });

      // กำลังไปหน้าถาม — ค้างไว้ไม่ให้แอป mount แล้วเริ่มงานของ Main
      if (result === "redirected") await holdUntilNavigation();
    } catch (error) {
      console.warn("[seatMain] ตรวจที่นั่งไม่สำเร็จ ปล่อยใช้ไปก่อน", error);
    }
  },
});
